import React, { Component } from 'react'
import { meta } from 'helpers/decorators'

@meta({
  title: 'Logs',
  intlKey: 'pageTitle.logs'
})
class MyNationalOfficeLogs extends Component {
  render() {
    return (
      <div>
        MyNationalOfficeLogs
      </div>
    )
  }
}

export default MyNationalOfficeLogs
